import { render, staticRenderFns } from "./PurchaseIngredientsTab.vue?vue&type=template&id=f072f70a&scoped=true&"
import script from "./PurchaseIngredientsTab.vue?vue&type=script&lang=js&"
export * from "./PurchaseIngredientsTab.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseIngredientsTab.vue?vue&type=style&index=0&id=f072f70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f072f70a",
  null
  
)

export default component.exports